// extracted by mini-css-extract-plugin
export default {"buttonBlue":"Button_buttonBlue__sJIUh","buttonLight":"Button_buttonLight__CFKG+"};